import styles from './style.css'

class NoDataDisplay extends React.Component {
  render () {
    return (
      <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center wrapper-container ${styles.wrapper} ${this.props.classPath}`}>
        <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles['img-wrapper']}`}>
          <img src={require('../../assets/images/backoffice/no-transaction.png')}
            className={styles.img}
            alt='no sales'
            width='110px'
          />
        </div>
        <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles['title-wrapper']}`}>
          <h3 className={styles['title']}>{this.props.title}</h3>
        </div>
        <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.description}`}>
          <p>
            {this.props.description}
          </p>
        </div>
      </div>
    )
  }
}

NoDataDisplay.propTypes = {
  className: React.PropTypes.string
}

export default NoDataDisplay



// WEBPACK FOOTER //
// ./app/components/NoDataDisplay/NoDataDisplay.js